import { Component, createComponent, Injectable, ViewContainerRef } from '@angular/core';
import { takeUntil } from 'rxjs';

/*
 */
@Injectable({
  providedIn: 'root',
})
export class ModalService {
  private _container: ViewContainerRef = null;
  private _active_view = null;
  private _subs = [];

  /*
   */
  constructor() {}

  /*
   */
  public container = (): ViewContainerRef => this._container;

  /*
   */
  public setContainer(container: ViewContainerRef) {
    this._container = container;
  }

  /*
   */
  public getActiveView = () => this._active_view?.instance;

  /*
   */
  public clear() {
    if (this._subs.length) {
      this._subs.map((el) => el.unsubscribe());
      this._subs = [];
    }
    if (this._active_view) {
      this._active_view.destroy();
      this._container.clear();
    }
  }

  /*
   */
  public load_view(component: any /* Todo */, on_closed: (val: any) => void, opts?: any) {
    this.clear();
    this._active_view = this._container.createComponent(component);

    if (on_closed) {
      this._subs.push(this._active_view.instance?.on_closed.subscribe((res) => on_closed(res)));
    }

    if (opts) {
      Object.keys(opts).map((k) => (this._active_view.instance[k] = opts[k]));
    }
  }
}
